import { prize, prizeType } from "../../../utils/timer";
import { MoneyInChip } from "../../tournament/hook/useEditTournament";
import { Timer5PrizeBoxWrapper } from "../timer5/styles/vertical";

const VerticalTimerPrizeBox = ({
  data,
  item,
  index,
  subPrizeFont,
}: {
  data: any;
  item: MoneyInChip;
  index: number;
  subPrizeFont: number;
}) => {
  return (
    <Timer5PrizeBoxWrapper subPrizeFont={subPrizeFont}>
      <span>{prize(data, item, index)}</span> {prizeType(item)}
      {item.subPrize && <div className="sub">{item.subPrize}</div>}
    </Timer5PrizeBoxWrapper>
  );
};

export default VerticalTimerPrizeBox;
